import {HolyOrdersSacramentSvg} from "../../../../components/Svgs/HolyOrdersSacramentSvg";
import React from "react";
import {BaptismSacramentSvg} from "../../../../components/Svgs/BaptismSacramentSvg";
import {FirstCommunionSacramentSvg} from "../../../../components/Svgs/FirstCommunionSacramentSvg";
import {ConfirmationSacramentSvg} from "../../../../components/Svgs/ConfirmationSacramentSvg";
import {MatrimonySacramentSvg} from "../../../../components/Svgs/MatrimonySacramentSvg";

export const SacramentTypes = [
  {
    value: 'baptism',
    label: 'sacrament of baptism',
    icon: <BaptismSacramentSvg />,
  },
  {
    value: 'first_communion',
    label: 'first communion',
    icon: <FirstCommunionSacramentSvg />,
  },
  {
    value: 'confirmation',
    label: 'sacrament of confirmation',
    icon: <ConfirmationSacramentSvg />,
  },
  {
    value: 'matrimony',
    label: 'sacrament of matrimony',
    icon: <MatrimonySacramentSvg />,
  },
  {
    value: 'holy_orders',
    label: 'sacrament of holy orders',
    icon: <HolyOrdersSacramentSvg />,
  },
]